import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
`;
